import React from 'react';

const Cookies = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 leading-relaxed">
        Our cookie policy covers:
      </p>
      <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-600">
        <li>Essential cookies for site functionality</li>
        <li>Analytics cookies to improve our services</li>
        <li>Preference cookies to remember your settings</li>
      </ul>
    </div>
  );
};

export default Cookies;